import React from  "react"
// import TrendingSong from "./TrendingSong"


export default ({music}) => <div className="rankingsPanel">
<h2>Top Songs</h2>
{/* <TrendingSong/>
<TrendingSong/>
<TrendingSong/>
<TrendingSong/>
<TrendingSong/>
<TrendingSong/>
<TrendingSong/> */}
</div>